import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { globalPropTypes } from 'helpers';
import reducer, { defaultState, updateFieldCreator } from './reducer';
import {
  createIpmaCisCreator,
  loadClientMemberAssociationsByCBCreator,
  loadGlobalCisCertificatesAttributesCreator,
  setIpmaCisCreateErrorsCreator,
  setIpmaCisCreatedCreator,
} from '../../../../../store/actionsCreators';
import AddCertificate from '../../../../../shared/Cis/Certificates/Add/AddCertificate';

const AddIpmaCertificate = ({
  errors,
  createCertificate,
  removeError,
  certificationBodies,
  levelDomains,
  loadCertificatesAttributes,
  organizations,
  loadClientMemberAssociations,
  memberAssociations,
  createdHolder,
  resetCreatedHolder,
  languages,
}) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <AddCertificate
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      createCertificate={createCertificate}
      removeError={removeError}
      certificationBodies={certificationBodies}
      loadCertificatesAttributes={loadCertificatesAttributes}
      levelDomains={levelDomains}
      organizations={organizations}
      loadClientMemberAssociations={loadClientMemberAssociations}
      memberAssociations={memberAssociations}
      createdHolder={createdHolder}
      resetCreatedHolder={resetCreatedHolder}
      type="ipma"
      languages={languages}
    />
  );
};

AddIpmaCertificate.propTypes = {
  errors: PropTypes.shape({
    certificateHolder: PropTypes.string,
    certificateLevelDomain: PropTypes.string,
    certificationBody: PropTypes.string,
    issueDate: PropTypes.string,
    type: PropTypes.string,
    validUntil: PropTypes.string,
    certId: PropTypes.string,
    holderAuthorized: PropTypes.string,
    visibility: PropTypes.string,
    organization: PropTypes.string,
    memberAssociation: PropTypes.string,
  }),
  createCertificate: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  certificationBodies: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  levelDomains: PropTypes.arrayOf(globalPropTypes.ChooseDataPropsTypes).isRequired,
  loadCertificatesAttributes: PropTypes.func.isRequired,
  createdHolder: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  resetCreatedHolder: PropTypes.func.isRequired,
};

AddIpmaCertificate.defaultProps = {
  createdHolder: {},
  errors: {},
};

const mapStateToProps = ({ ipma, globals }) => ({
  errors: ipma.cis.certificates.createErrors,
  certificationBodies: globals.cis.certificationBodies,
  levelDomains: globals.cis.levelDomains,
  organizations: globals.cis.organizations,
  memberAssociations: globals.cis.clientMemberAssociations,
  createdHolder: ipma.cis.certificateHolders.created,
  languages: globals.languages,
});

const mapDispatchToProps = (dispatch) => ({
  createCertificate: (payload, history) =>
    dispatch(createIpmaCisCreator('certificates', payload, history)),
  removeError: (payload) => dispatch(setIpmaCisCreateErrorsCreator('certificates', payload)),
  loadCertificatesAttributes: () => dispatch(loadGlobalCisCertificatesAttributesCreator()),
  loadClientMemberAssociations: (payload) =>
    dispatch(loadClientMemberAssociationsByCBCreator(payload)),
  resetCreatedHolder: () => dispatch(setIpmaCisCreatedCreator('certificateHolders', undefined)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddIpmaCertificate);
